export class PatchEditor {
    /**
     * @type {HTMLDivElement}
     */
    node;

    svg;

    svgNamespace = "http://www.w3.org/2000/svg";

    selectedElement;

    translations;

    designBackup;

    constructor(node) {
        this.node = node;
        this.translations = this.node.querySelector('#translations').dataset;
        this.node.querySelectorAll('.patch_controls').forEach(element => {
            element.classList.remove('d-none');
        });
        this.node.querySelector('.step-design #inlay-stones').classList.add('d-none');
        this.createSvg();
        this.drawText('MT');
        this.drawStone();
        this.initEvents();
        this.updateElementList();
        this.initAddButton();
    }

    reset() {
        this.node.querySelectorAll('.patch_controls').forEach(element => {
            element.classList.add('d-none')
        });
        this.node.querySelector('.step-design #inlay-stones').classList.remove('d-none');
        this.node.querySelector('.step-design #inlay-stones input.tab1').checked = true;
        this.updateElementList(true);
        this.node.querySelector('.substep-patch .design').innerHTML = this.designBackup;
        this.designBackup = null;
        this.node.removeEventListener('click', this.clickEventHandler)
    }

    initEvents() {
        let _self = this;

        this.clickEventHandler = function (event) {
            let element = event.target.closest('.add-stone')
            if (null !== element) {
                _self.drawStone(_self.getRandomInt(0, 200), _self.getRandomInt(0, 200));
                _self.updateElementList();
            }

            element = event.target.closest('.edit-stone');
            if (null !== element) {
                _self.editStone(element);
            }

            element = event.target.closest('.add-letter');
            if (null !== element) {
                event.preventDefault();
                _self.drawText('W');
                _self.updateElementList();
            }

            element = event.target.closest('.element-control');
            if (null !== element) {
                _self.initControls(element);
            } else {
                _self.node.querySelectorAll('.row_slider_control').forEach(slider => {
                    slider.remove();
                });
            }

            element = event.target.closest('button.add-to-cart')
            if (null !== element) {
                event.preventDefault();
                _self.saveSvg();
                event.target.closest('form').submit();
            }
        }

        this.node.addEventListener('click', this.clickEventHandler);
    }

    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);

        return Math.floor(Math.random() * (max - min)) + min;
    }

    initDrag(svgNode) {
        let selectedElement = null;
        let offset = null;
        let nameX = 'x';
        let nameY = 'y';

        svgNode.addEventListener('mousedown', startDrag);
        svgNode.addEventListener('mousemove', drag);
        svgNode.addEventListener('mouseup', endDrag);
        svgNode.addEventListener('mouseleave', endDrag);

        //touch
        svgNode.addEventListener('touchstart', startDrag);
        svgNode.addEventListener('touchmove', drag);
        svgNode.addEventListener('touchend', endDrag);
        svgNode.addEventListener('touchleave', endDrag);
        svgNode.addEventListener('touchcancel', endDrag);

        function startDrag(event) {
            if (true === event.target.classList.contains('draggable')) {
                selectedElement = event.target;
                nameX = 'x';
                nameY = 'y';

                if ('circle' === selectedElement.tagName) {
                    nameX = 'cx';
                    nameY = 'cy';
                }

                offset = getMousePosition(event);
                offset.x -= parseFloat(selectedElement.getAttributeNS(null, nameX));
                offset.y -= parseFloat(selectedElement.getAttributeNS(null, nameY));
            }
        }

        function drag(event) {
            if (null !== selectedElement) {
                event.preventDefault();

                const position = getMousePosition(event);

                selectedElement.setAttributeNS(null, nameX, (position.x - offset.x).toString());
                selectedElement.setAttributeNS(null, nameY, (position.y - offset.y).toString());
            }
        }

        function endDrag() {
            selectedElement = null;
        }

        function getMousePosition(event) {
            const CTM = svgNode.getScreenCTM();
            if (event.touches) {
                event = event.touches[0];
            }

            return {
                x: (event.clientX - CTM.e) / CTM.a,
                y: (event.clientY - CTM.f) / CTM.d
            };
        }
    }

    initControls(controlElement) {
        let row = controlElement.closest('.row');
        let target = this.node.querySelector('#' + row.dataset.target);
        if (null === controlElement.querySelector('.row_slider_control')) {
            this.node.querySelectorAll('.row_slider_control').forEach(slider => {
                slider.remove();
            });
            if (true === controlElement.classList.contains('size') || true === controlElement.classList.contains('rotation')) {

                let type = 'size';
                if (true === controlElement.classList.contains('rotation')) {
                    type = 'rotation';
                }
                let controller = this.node.querySelector('#configurator_template_element_list_row_slider_' + type).content.cloneNode(true);
                let input = controller.querySelector('input');
                let text = controlElement.querySelector('span');
                input.addEventListener('input', event => {
                    text.textContent = event.target.value;
                    this.updateElement(row);
                });

                input.value = text.textContent;

                controlElement.appendChild(controller);
            }

            if (true === controlElement.classList.contains('color')) {
                let controller = this.node.querySelector('#configurator_template_element_list_row_slider_color').content.cloneNode(true);
                let color = controlElement.querySelector('.color');
                controller.querySelector('.row_slider_control').addEventListener('click', event => {

                    let target = event.target.closest('.color.button');
                    if (null !== target) {
                        color.style.backgroundColor = getComputedStyle(target).backgroundColor;
                        controlElement.querySelector('.row_slider_control').remove();
                        this.updateElement(row);
                    }
                });

                controlElement.appendChild(controller);
            }
        }
    }


    updateElement(row) {
        let target = this.svg.querySelector('#' + row.dataset.target);

        target.setAttribute('font-size', row.querySelector('.element-control.size>span').textContent);

        target.style.transform = 'rotate(' + row.querySelector('.element-control.rotation>span').textContent + 'deg)';

        target.setAttribute('fill', row.querySelector('.element-control.color>.color').style.backgroundColor);
    }

    saveSvg() {
        let svgContent = this.svg;
        let radius = 14;
        svgContent.querySelectorAll('image').forEach(image => {
            let stoneGroup = document.createElementNS(this.svgNamespace, 'g');
            let circle = document.createElementNS(this.svgNamespace, 'circle');
            circle.setAttribute('stroke-width', '3');
            circle.setAttribute('fill', 'white');
            circle.setAttribute('fill-opacity', '0');
            circle.setAttribute('stroke', 'black');
            circle.setAttribute('r', '14');
            circle.setAttribute('cx', (parseInt(image.getAttribute('x')) + radius).toString());
            circle.setAttribute('cy', (parseInt(image.getAttribute('y')) + radius).toString());
            let text = document.createElementNS(this.svgNamespace, 'text');
            text.textContent = image.dataset.stoneId;
            text.setAttribute('font-size', '15');
            text.setAttribute('font-weight', 'bold');
            text.setAttribute('dominant-baseline', 'middle');
            text.setAttribute('text-anchor', 'middle');
            text.setAttribute('x', (parseInt(image.getAttribute('x')) + radius).toString());
            text.setAttribute('y', (parseInt(image.getAttribute('y')) + radius + 2.5).toString());
            stoneGroup.appendChild(circle);
            stoneGroup.appendChild(text);

            image.replaceWith(stoneGroup);
        });
        svgContent = svgContent.outerHTML;
        let textarea = this.node.querySelector('textarea#patchdesign');
        textarea.value = svgContent;
    }

    createSvg() {
        this.svg = document.createElementNS(this.svgNamespace, 'svg');
        this.svg.setAttribute('viewBox', '0 0 200 220');
        this.svg.setAttribute('width', '200');
        this.svg.setAttribute('height', '220');
        this.svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

        let textGroup = document.createElementNS(this.svgNamespace, 'g');
        textGroup.id = 'text';
        this.svg.appendChild(textGroup);

        let container = this.node.querySelector('.substep-patch .design');
        this.designBackup = container.innerHTML;
        container.innerHTML = '';
        container.appendChild(this.svg);

        this.initDrag(this.svg);
    }

    drawStone(x = 130, y = 35) {
        const stoneCount = this.node.querySelectorAll('.design svg image.stone-slot-trigger').length;
        if (3 <= stoneCount) {
            return;
        }

        const classTemplate = 'configurator_svg_stone_';
        let stoneId;
        for (stoneId = 1; stoneId <= stoneCount; ++stoneId) {
            if (null === this.node.querySelector('svg #' + classTemplate + stoneId)) {
                break;
            }
        }

        let stone = document.createElementNS(this.svgNamespace, 'image');
        let defaultStone = this.node.parentElement.querySelector('#inlay-stones .stone:first-child');
        stone.setAttribute('x', x);
        stone.setAttribute('y', y);
        stone.setAttribute('width', '30');
        stone.setAttribute('href', defaultStone.querySelector('img').src);
        stone.setAttribute('data-stone-id', defaultStone.dataset.stoneId);
        stone.classList.add('draggable');
        stone.classList.add('configurator-element');
        stone.classList.add('stone-slot-trigger');
        stone.id = classTemplate + stoneId;
        stone.dataset.name = defaultStone.querySelector('img').getAttribute('alt');
        this.svg.appendChild(stone);
    }

    editStone(stoneButton) {
        const modal = this.node.querySelector('#configurator_template_modal_stone_picker').content.cloneNode(true);
        let stonepicker = this.node.querySelector('#inlay-stones .tabbed').cloneNode(true);
        stonepicker.querySelectorAll('input').forEach(input => {
            input.id = 'modal_' + input.id;
        });
        stonepicker.querySelectorAll('label').forEach(label => {
            label.setAttribute('for', 'modal_' + label.getAttribute('for'))
        });
        stonepicker.querySelector('input.tab1').checked = true;
        stonepicker.classList.remove('d-none');
        modal.querySelector('.body').appendChild(stonepicker);

        modal.querySelector('.current-selection img').setAttribute('src', stoneButton.querySelector('img').getAttribute('src'));
        modal.querySelector('.current-selection').dataset.name = stoneButton.dataset.name;
        modal.querySelector('.current-selection').dataset.id = stoneButton.dataset.id;

        modal.querySelector('.current-selection img').setAttribute('src', stoneButton.querySelector('img').getAttribute('src'));
        modal.querySelector('.modal').addEventListener('click', event => {
            let target = event.target.closest('.save');
            let domModal = this.node.closest('body').querySelector('.stone-picker');
            if (null !== target) {
                let currentSelection = domModal.querySelector('.current-selection');
                let svgStone = this.svg.querySelector('#' + stoneButton.dataset.target);
                svgStone.setAttribute('href', currentSelection.querySelector('img').getAttribute('src'));
                svgStone.setAttribute('data-stone-id', currentSelection.dataset.id)
                svgStone.setAttribute('data-name', currentSelection.dataset.name)
                this.updateElementList();
                domModal.remove();
            }

            target = event.target.closest('.delete');
            if (null !== target) {
                let targetStone = this.svg.querySelector('#' + stoneButton.dataset.target);

                if (null !== targetStone) {
                    targetStone.remove();
                    this.updateElementList();
                }

                domModal.remove();
            }

            target = event.target.closest('.stone');
            if (null !== target) {
                let currentSelection = domModal.querySelector('.current-selection');
                currentSelection.dataset.id = target.dataset.stoneId;
                currentSelection.dataset.name = target.querySelector('img').getAttribute('alt');
                currentSelection.querySelector('img').setAttribute('src', target.querySelector('img').getAttribute('src'));
            }
        });

        this.node.closest('body').appendChild(modal);
    }

    drawText(textToDraw) {
        let text = textToDraw.split('');

        let config = {
            'font-size': 120,
            'data-rotate': '0',
            "dominant-baseline": "middle",
            "text-anchor": "middle",
            'font-family': 'bodoni flf',
            'style': 'transform-origin:center;transform-box:fill-box',
            'fill': 'rgb(0, 8, 73)'
        }

        let letterConfig = [
            {
                x: 72,
                y: 90,
            },
            {
                x: 148,
                y: 172,
            },
        ];

        for (let key in text) {
            let textElements = this.svg.querySelectorAll('text');
            if (3 <= textElements.length) {
                return;
            }
            let newId = 1;
            let highestExistingId = 0;
            textElements.forEach(element => {
                if (highestExistingId <= parseInt(element.dataset.id)) {
                    highestExistingId = parseInt(element.dataset.id);
                }
            });

            if (newId <= highestExistingId) {
                newId = highestExistingId + 1;
            }

            let textElement = document.createElementNS(this.svgNamespace, "text");
            textElement.classList.add('draggable');
            textElement.classList.add('configurator-element');
            textElement.id = 'configurator_svg_text_' + newId;
            textElement.dataset.id = newId;
            for (let name in letterConfig[key]) {
                textElement.setAttributeNS(null, name, letterConfig[key][name]);
            }
            for (let name in config) {
                textElement.setAttributeNS(null, name, config[name]);
            }
            this.svg.querySelector('g#text').appendChild(textElement);

            textElement.textContent = text[key];
        }
    }

    updateElementList(reset = false) {
        const table = this.node.querySelector('.element-list .list-container');
        const stoneContainer = this.node.querySelector('.element-list .stones .container');
        const rowTemplate = this.node.querySelector('#configurator_template_element_list_row').content;
        const stoneTemplate = this.node.querySelector('#configurator_template_element_list_stone').content;

        table.innerHTML = '';
        stoneContainer.innerHTML = '';
        if (true === reset) {
            return;
        }
        let letters = this.node.querySelectorAll('.design svg text.configurator-element');
        let stones = this.node.querySelectorAll('.design svg image.configurator-element');

        if(3 <= letters.length){
            this.node.querySelector('a.add-letter').classList.add('d-none');
        }else{
            this.node.querySelector('a.add-letter').classList.remove('d-none');
        }
        if(3 <= stones.length){
            this.node.querySelector('div.add-stone').classList.add('d-none');
        }else{
            this.node.querySelector('div.add-stone').classList.remove('d-none');
        }
        letters.forEach(svgElement => {
            let row = rowTemplate.cloneNode(true);
            row.querySelector('.row').dataset.target = svgElement.id;
            row.querySelector('.element-control.name>input').value = svgElement.textContent;
            row.querySelector('.element-control.size>span').textContent = svgElement.getAttribute('font-size');
            row.querySelector('.element-control.rotation>span').textContent = svgElement.dataset.rotate;
            row.querySelector('.buttons>.delete').dataset.target = svgElement.id;
            row.querySelector('.buttons>.delete').addEventListener('click', event => {
                let button = event.target.closest('button');
                this.node.querySelector('.design svg #' + button.dataset.target).remove();
                this.updateElementList();
            });
            row.querySelector('.element-control.name>input').addEventListener('keyup', event => {
                this.node.querySelector('.design svg #' + event.target.closest('.row').dataset.target).textContent = event.target.value.trim().charAt(0);
            });

            table.appendChild(row);
        });

        stones.forEach(svgElement => {
            let stoneButton = stoneTemplate.cloneNode(true);
            stoneButton.querySelector('.edit-stone').dataset.id = svgElement.dataset.stondeId;
            stoneButton.querySelector('.edit-stone').dataset.name = svgElement.dataset.name;
            stoneButton.querySelector('.edit-stone').dataset.target = svgElement.id;
            stoneButton.querySelector('img').src = svgElement.getAttribute('href');
            stoneButton.querySelector('img').alt = svgElement.dataset.name;
            stoneButton.querySelector('span').textContent = svgElement.dataset.name;

            stoneContainer.appendChild(stoneButton);
        });
    }

    initAddButton() {
        let container = this.node.querySelector('.element-list .stones');
        let defaultStone = document.querySelector('#inlay-stones .stone>img');
        // container.querySelector('.add-stone>img').setAttribute('src', defaultStone.getAttribute('src'));
    }

    getStones() {
        let stones = [];
        this.svg.querySelectorAll('.stone-slot-trigger').forEach(stoneSlot => {
            stones.push(stoneSlot.dataset.stoneId);
        });

        return stones;
    }
}